import { RankedTester, rankWith, uiTypeIs } from "@jsonforms/core";

export const horizontalLayoutTester: RankedTester = rankWith(3, uiTypeIs("HorizontalLayout"));
